export default "__VITE_ASSET__bb925800__"